export default __webpack_public_path__ + "static/media/home-6.a98bba94.png";